export default __webpack_public_path__ + "static/media/html5.8ae3d4ad.svg";